<template>
  <div>
    <CJumbotron v-if="this.$store.state.data.access_level == 1" class="tickets">
      <h1 class="display-3">
        {{ $t("properties.page_tittle") }}
      </h1>
      <p class="lead">
        <b
          style="font-weight: 100;color: #00325a;padding-bottom: 10px;display: inline-block;"
        >
          در این صفحه لیست اموال همراه با برچسب‌های آن‌ها قابل مدیریت است.
        </b>
      </p>
    </CJumbotron>

    <CCard>
      <CCardHeader class="hamkaran_header"> فیلتر گزارشات </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol md="3">
            <CInput
              label="کلید واژه اموال ... "
              placeholder="عبارت را جهت جستجو وارد نمایید"
              v-on:keyup.enter="
                page = 1;
                pagPage = 1;
                pages = 0;
                getData();
              "
              v-model="q"
            />
          </CCol>
        </CRow>
      </CCardBody>
      <CCardFooter>
        <div
          style="text-align: left;
                display: inline-block;
                float: left;
                margin-right: 10px;"
        >
          <CButton
            @click="
              page = 1;
              pagPage = 1;
              pages = 0;
              getData();
            "
            color="primary"
          >
            جستجو
          </CButton>
        </div>

        <div style="text-align: right; float: right; display: inline-block">
          <CButton
            style="color:#fff"
            @click="modal_show();"
            color="info"
          >
          {{ $t("properties.add_new_btn") }}
          </CButton>
        </div>
      </CCardFooter>
    </CCard>


    <CCard>
      <CCardBody class="mhcloud">
        <CElementCover v-if="loading" :opacity="1" class="h-loadin">
          <CSpinner size="5xl" />
          <br />
          <div>در حال بارگزاری</div>
        </CElementCover>
        <CRow v-if="showProducts" class="hamkaran-report">
          <CCol md="12" sm="12">
            <div style="position: relative">
              <div class="table-responsive">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th style="width: 10px">#</th>
                      <th>{{ $t("properties.data.title.name") }}</th>
                      <th>{{ $t("properties.data.property_labels.name") }}</th>
                      <th>{{ $t("properties.data.description.name") }}</th>
                      <th>{{ $t("properties.data.date.name") }}</th>
                      <th style="text-align: center; width: 100px">
                        {{ $t("properties.data.operations.name") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in rows" :key="row.id">
                      <td class="id">{{ row.id }}</td>
                      <td class="name">{{ row.title }}</td>
                      <td class="name" style="white-space: pre-line;">{{ row.labels }}</td>
                      <td class="name">{{ row.description }}</td>
                      <td :title="new Date(row.created_at)
                            | moment('dddd, jMMMM Do jYYYY, h:mm:ss a') ">
                        {{ new Date(row.created_at) | moment("from", "now") }}
                      </td>
                      <td class="oprate">
                        <CButtonGroup>
                          <CButton
                            color="success"
                            size="sm"
                            @click="modal_show(row);"
                          >
                            <i class="fa-solid fa-edit"></i>
                            ویرایش
                          </CButton>
                        </CButtonGroup>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <div id="integration">
      <CPagination
        :activePage.sync="pagPage"
        :pages="pages"
        v-on.update:activePage="changePage()"
        size="lg"
        align="center"
      />
    </div>
    <CModal
      :title="add_new.title"
      color="info"
      size="lg"
      :show.sync="showForm"
    >
      <CRow>
        <CCol md="12">
          <CInput
            :label="$t('properties.data.title.name')"
            :placeholder="$t('properties.data.title.placeholder')"
            v-model="asset.title"
          />
        </CCol>
        <CCol md="12">
          <CTextarea
              v-model="asset.labels"
              :label="$t('properties.data.property_labels.name')"
              rows="6"
            ></CTextarea>
        </CCol>
        <CCol md="12">
          <CTextarea
              v-model="asset.description"
              :label="$t('properties.data.description.name')"
              rows="2"
            ></CTextarea>
        </CCol>

      </CROW>

      <button
        slot="footer"
        type="button"
        class="btn btn-secondary"
        @click="showForm = false"
      >
        {{ $t("common.CANCEL") }}
      </button>

      <CButton
        slot="footer"
        type="button"
        class="btn btn-info"
        @click="saveData()"
      >
        <CSpinner v-if="storeLoading" tag="span" size="md" />
        <CIcon v-if="!storeLoading" class="top_menu" name="cil-save" />
        <span v-if="!storeLoading"> {{ add_new.btn }} </span>
      </CButton>
    </CModal>
  </div>
</template>
<style>
@media (max-width: 576px) {
  .row.d-sm-none.tickets_tables_header {
    display: none !important;
  }
  .row.tickets_table div {
    display: flex !important;
    justify-content: flex-start;
    align-content: flex-start;
    flex-direction: row;
    text-align: right;
    line-height: 30px;
  }
  .row.tickets_table div a.btn.btn-outline-primary {
    margin-top: 11px;
  }
}
span.bg_ani {
  top: -10px;
  position: absolute;
  left: -14px;
  opacity: 1;
  z-index: 0;
}

.red {
  color: #d40000;
}
.ltr.form-group input {
  direction: ltr;
}
.integrationMessage {
  position: absolute;
  display: block;
  right: 13px;
  /* float: right; */
}
.integration_help {
  text-align: right;
  background: #eee;
  padding: 19px 10px;
  margin-bottom: 15px;
  border-radius: 6px;
}
.box.not_active.not_membership {
  background: #fbcaca;
  border-color: #f56f6f;
  filter: blur(0.2px);
  color: red;
}
.box.not_active:hover {
  background: #efefef;
  animation: none;
  border: 1px solid #333;
  color: #727272;
}

.box.not_active {
  filter: blur(1px);
  cursor: no-drop;
}
.box img {
  width: 91px;
  line-height: 40px;
  display: inline-block;
  padding: 21px 10px;
  filter: grayscale(1);
}
.box {
  width: 106px;
  background: #efefef;
  transition: 0.3s all;
  height: 95px;
  border-radius: 5px;
  border: 1px solid #333;
  padding: 5px;
  cursor: pointer;
  margin: 14px 5px;
  float: right;
}
.box span {
  font-size: 12px;
}
.box i {
  display: block;
  font-size: 52px;
  padding-bottom: 8px;
  padding-top: 4px;
}
.mhcloud h1 {
  display: inline-block;
  width: 100%;
  text-align: right;
  font-weight: 100;
}
.box:hover {
  background: #01b0cf;
  color: #fff;
  border-color: #0091bb;
}
.edit_btn {
  width: 21px;
  height: 21px;
  padding: 0px;
  margin-right: 10px;
}
.box:hover {
  animation: zoom-in-zoom-out 2.5s ease-out infinite;
}
.tickets_table {
  border-radius: 3px;
  border: 1px solid rgb(211 213 225 / 45%);
  padding: 10px 0px;
  text-align: center;
  margin: 5px 0px;
}
.tickets_table:hover {
  cursor: pointer;
  background: rgba(238, 238, 238, 0.589);
}
.center {
  display: flex;
  align-content: space-around;
  flex-wrap: nowrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.row.tickets_tables_header {
  border-radius: 3px;
  border: 0px solid rgb(211 213 225 / 45%);
  padding: 10px 0px;
  text-align: center;
  margin: 5px 0px;
  color: #727272;
}
.jumbotron.tickets .btn {
  margin: 0px 5px;
}
.row.ticket p {
  white-space: break-spaces;
}
</style>
<script>
export default {
  watch: {
    "product.base_price"(val) {
      let formatted = new Intl.NumberFormat("en", {
        currency: "IRR",
        style: "currency",
      })
        .format(val)
        .replace("IRR", "");
      this.basePrice = formatted + " ریال";
    },
  },
  name: "properties_index",
  components: {},

  data() {
    return {
      data: null,
      page: 1,
      pagPage: 1,
      pages: 0,
      q: "",
      showForm:false,
      storeLoading: false,
      rows: null,
      loading: true,
      showProducts: false,
      showEmpty: false,
      basePrice: "",
      uploadUrl: "https://api.hamkaran.cloud/api/v1/files-upload",
      uploadHeaders: {},
      fileRecordsForUpload: [],
      asset: {
        id: "",
        title:"",
        description: "",
        labels: ""
      },
      add_new: {
        title: "",
        btn:"",
      },
    };
  },
  created() {
    this.$root.$i18n.locale = "fa";
  },
  mounted() {
    this.q = this.$route.params.prefix ? this.$route.params.prefix : "";
    this.getData();
  },
  methods: {
    numberFormat (val) { 
      let formatted = new Intl.NumberFormat("en", {
        currency: "IRR",
        style: "currency",
      })
        .format(val)
        .replace("IRR", "");
      return formatted + " ریال";
    },
    go(target) {
      this.$router.push({ path: target });
    },
    modal_show: function(data) {
      this.showForm = true;
      // add new
      if(data){
        this.add_new.btn = this.$t("properties.edit_btn");
        this.add_new.title = this.$t("properties.edit_btn");
        this.asset.id=data.id;
        this.asset.title=data.title;
        this.asset.description= data.description;
        this.asset.labels=data.labels;

      }else{
        this.add_new.btn = this.$t("properties.add_new_btn");
        this.add_new.title = this.$t("properties.add_new_title");
        this.asset.id=0;
        this.asset.title='';
        this.asset.description='';
        this.asset.labels='';
      }
    
    },
    getData: function() {
      this.loading = true;
      var token = localStorage.getItem("token");
      if (token)
        axios.defaults.headers.common.Authorization = "Bearer " + token;

      axios
        .get(
          "https://api.hamkaran.cloud/api/v1/admin/assets?datefrom=" +
            "&page=" +
            this.page +
            "&q=" +
            this.q
        )
        .then((response) => {
          this.loading = false;
          this.rows = response.data.data.data;
          this.showProducts = this.rows.length > 0 ? 1 : 0;
          this.showEmpty = this.rows.length == 0 ? 1 : 0;
          this.pages = response.data.data.last_page;
        })
        .catch((error) => {
          const count = this.$store.state.alert.successcount + 1;
          const alert = {
            error_msg: {
              statusText: "Eroor",
              status: "500",
              data: ["خطا بارگزاری اطلاعات"],
            },
            successMessage: "",
            successcount: 0,
            errorcount: count,
          };
          this.$store.commit("set", ["alert", alert]);
        });
    },

    changePage: function() {
      if (this.pages) {
        if (this.page != this.pagPage) {
          this.page = this.pagPage;
          this.getData();
        }
      }
    },

    saveData: function() {
      var token = localStorage.getItem("token");
        if (token)
          axios.defaults.headers.common.Authorization = "Bearer " + token;
        axios
          .post(
            "https://api.hamkaran.cloud/api/v1/admin/asset",
            this.asset
          )
          .then((response) => {
            this.storeLoading = false;
            this.showForm = false;
            this.getData();
            const count = this.$store.state.alert.successcount + 1;
            const alert = {
              error_msg: {
                statusText: null,
                status: null,
                data: [],
              },
              successMessage: "save succes",
              successcount: count,
              errorcount: 0,
            };
            this.$store.commit("set", ["alert", alert]);
          })
          .catch((error) => {
            const count = this.$store.state.alert.errorcount + 1;
            console.log(error.response);
            this.storeLoading = false;
            const alert = {
              error_msg: {
                statusText: "خطا در ذخیره سازی",
                status: error.response.status,
                data: error.response.data,
              },
              successMessage: "",
              successcount: 0,
              errorcount: count,
            };
            this.$store.commit("set", ["alert", alert]);
          });
    },

  },
};
</script>
